<div class="row">
  <div class="col-9">
    <div class="mb-3">
      <span class="fw-bold">{{ organisme.name }}</span>
    </div>

    <div class="mb-3">
      <span class="fw-bold">Adresse : </span>
      {{ organisme.addressLine1 }} {{ organisme.addressLine2 }}
      {{ organisme.addressLine3 }}
    </div>

    <div class="row mb-3">
      <div class="col-6 text-start">
        <span class="fw-bold">Code postal :</span>
        {{ organisme.postalCode }}
      </div>
      <div class="col-6 text-start">
        <span class="fw-bold">Ville :</span>
        {{ organisme.city }}
      </div>
    </div>

    <div class="mb-3">
      <div>
        <span class="fw-bold">Domaine d'expertise : </span>
        <div class="ms-3">
          {{ organisme.expertise }}
        </div>
      </div>
    </div>

    <div *ngIf="organisme.services[0]" class="mb-3">
      <span class="fw-bold">{{ organisme.services[0].title }} : </span>
      <div class="ms-3">
        {{ organisme.services[0].description }}
      </div>
    </div>

    <div *ngIf="organisme.services[1]" class="mb-3">
      <span class="fw-bold">{{ organisme.services[1].title }} : </span>
      <div class="ms-3">
        {{ organisme.services[1].description }}
      </div>
    </div>
  </div>

  <div class="col-3 p-2">
    <p-photo-miniature
      [imageUrl]="organismeLogo"
      class="mb-3"
    ></p-photo-miniature>
    <p-photo-miniature [imageUrl]="organismePhoto"></p-photo-miniature>
  </div>
</div>
